import '../../styles/AssetLibrary.css';

import { AssetMetadata, AssetOwnerCategory } from '../../models/Asset';
import React, { useEffect, useState } from 'react';

import { ApolloError } from '@apollo/client';
import { AssetCard } from './AssetCard';
import { AssetUploading } from '../../hooks/useAssetStorage';
import { Button } from '@mui/material';
import ErrorPanel from '../ErrorPanel';
import Grid from '@mui/material/Unstable_Grid2';
import { SUPPORT_MESSAGE } from '../../constants';
import { isEqual } from 'lodash';

/** Number of items to show per paged view. */
const SHOW_ITEMS_PAGE = 100;

interface AssetsPanelProps {
  thumbnailWidth?: number;
  thumbnailHeight?: number;
  category: AssetOwnerCategory;
  lazyLoad: boolean;
  selectedAssetkey: string;
  assetFiles: AssetUploading[];
  assetsError: ApolloError;
  onUploadCompleted: (assetkey: string) => void;
  onUploadCanceled: (assetkey: string) => void;
  onUploadError: (assetkey: string) => void;
  onEncodeCompleted: (assetMetadata: AssetMetadata) => void;
  onEncodeError: (assetkey: string) => void;
  handleClick: (assetkey: string, endSelection?: boolean) => void;
  handleDelete: (asset: AssetMetadata) => void;
}

export const AssetsPanel = (props: AssetsPanelProps) => {
  const [assets, setAssets] = useState<AssetUploading[]>();
  const [showItems, setShowItems] = useState(SHOW_ITEMS_PAGE);

  useEffect(() => {
    if (!isEqual(assets, props.assetFiles)) {
      setShowItems(SHOW_ITEMS_PAGE);
      setAssets(props.assetFiles);
    }
  }, [props.assetFiles]);

  if (props.assetsError) {
    return (
      <ErrorPanel
        title="Whoops!"
        message="There was a problem with loading assets."
        details={SUPPORT_MESSAGE}
      />
    );
  }

  return (
    <>
      <Grid container alignItems="center" spacing={2} justifyContent="center">
        {assets?.slice(0, showItems).map((asset) => {
          return (
            <Grid key={asset.metadata.assetkey}>
              <AssetCard {...props} asset={asset} />
            </Grid>
          );
        })}
      </Grid>
      {props.assetFiles?.length > showItems && (
        <Grid container justifyContent="center">
          <Grid>
            <Button
              onClick={() => setShowItems((curr) => curr + SHOW_ITEMS_PAGE)}
              variant="contained"
              color="primary"
            >
              Show {props.assetFiles?.length - showItems} more
            </Button>
          </Grid>
        </Grid>
      )}
    </>
  );
};
